import { StatusReportPage } from '@/features/Transition360/StatusReports/StatusReportPage';
import { statusReportParams } from '@/features/Transition360/routeParams';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/transition-360/projects/$projectId/assets/$projectAssetId/status-reports/$statusReportId',
)({
    params: statusReportParams,
    component: StatusReportPageRoute,
});

function StatusReportPageRoute() {
    const { projectId, projectAssetId, statusReportId } = Route.useParams();
    return (
        <StatusReportPage
            projectId={projectId}
            projectAssetId={projectAssetId}
            statusReportId={statusReportId}
        />
    );
}
